export default [
    {
        path: '/checkCoffee',
        name: 'checkCoffee',
        meta: {
            title: '咖啡核销'
        },
        component: () => import('@/views/checkCoffee')
    },
]